import { post } from "helpers/api_helper";
import * as URL from "helpers/url_helper"

export const addOrder = data => post(URL.ADD_NEW_ORDER, data);
export const getOrderList = data => post(URL.GET_ORDER_LIST, data);
export const getOneOrder = data => post(URL.GET_ONE_ORDER, data);
export const updateOrder = data => post(URL.UPDATE_ORDER, data);
export const getOrderLog = data => post(URL.GET_CONFIRM_ORDERS_LOG, data);
export const getOrderStatus = data => post(URL.GET_ORDER_STATUS, data);
export const getOrderStatusCount = data => post(URL.GET_ORDER_STATUS_COUNT, data);
export const addConfirmOrder = data => post(URL.ADD_CONFIRM_NEW_ORDER, data);
export const getConfirmOrderList = data => post(URL.GET_CONFIRM_ORDER_LIST, data);
export const getOneConfirmOrder = data => post(URL.GET_ONE_CONFIRM_ORDER, data);
export const updateConfirmOrder = data => post(URL.UPDATE_CONFIRM_ORDER, data);
export const deleteConfirmOrder = data => post(URL.DELETE_CONFIRM_ORDER, data);
export const getShipmentDetails = data => post(URL.GET_SHIPMENT_DETAILS, data);
export const getOrdersStatusCount = data => post(URL.GET_ORDERS_STATUS_COUNT, data);
export const updateTrackingUrl = data => post(URL.UPDATE_TRACKING_URL, data);
export const getPlantsDropdown = data => post(URL.GET_PLANTS_LIST, data);
export const getPaymentTermsDropdown = data => post(URL.GET_PAYMENT_TERMS_LIST, data);
export const invoiceDownload = data => post(URL.DOWNLOAD_INVOICE, data);
export const getTrackingDetails = data => post(URL.GET_TRACKING_DETAILS, data);
export const getTrackingDetailsList = data => post(URL.GET_TRACKING_DETAILS_LIST, data);
export const addOrUpdateTrackingDetails = data => post(URL.ADD_OR_UPDATE_TRACKING_DETAILS, data);